import { createVanIconComponent } from "./van"

const GiftCardOutlined = createVanIconComponent("gift-card-o")
export default GiftCardOutlined
